export const SET_DOCUMENTS_TITLES_ALL= "SET_DOCUMENTS_TITLES_ALL"
export const SET_DOCUMENTS_TITLES= "SET_DOCUMENTS_TITLES"
export const SET_KEYWORDS_LIST= "SET_KEYWORDS_LIST"
export const SET_SELECTED_KEYWORDS_LIST = "SET_SELECTED_KEYWORDS_LIST"
